import { createStore } from 'vuex';

import adDeployment from '@/components/ad-deployment/store/index.js';
import adStudio from '@/components/ad-studio/store/index.js';
import onboarding from '@/components/onboarding/workflow/store/index.js';
import playbookManagement from '@/components/playbook-management/store/index.js';

import agency from './modules/agency';
import brand from './modules/brand';
import dealer from './modules/dealer';
import metrics from './modules/metrics';
import monitoring from './modules/monitoring';
import report from './modules/report';
import settings from './modules/settings';
import support from './modules/support';
import user from './modules/user';

const store = createStore({
    modules: {
        user,
        brand,
        dealer,
        agency,
        report,
        metrics,
        support,
        settings,
        adStudio,
        monitoring,
        onboarding,
        adDeployment,
        playbookManagement,
    },
});
export default store;
